import { render, staticRenderFns } from "./initial.vue?vue&type=template&id=758534b0&lang=pug&"
import script from "./initial.vue?vue&type=script&lang=js&"
export * from "./initial.vue?vue&type=script&lang=js&"
import style0 from "./initial.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "initial.vue"
export default component.exports